<template>
  <div class="header">
    <h1>用戶管理 - 企業列表</h1>
    <div class="d-flex align-items-center col-9 justify-content-end">
      <button
        v-if="$store.state.userInfo.auth_data && $store.state.userInfo.auth_data !== true ? Object.values($store.state.userInfo.auth_data).includes('sign/up') : true"
        @click="$router.push('/user-management/create-user')"
        class="btn btn-outline-primary col-5 add-user me-5"
      >
        新增用戶
      </button>
      <div
        @click="exportExcel"
        style="cursor: pointer"
        class="d-flex align-items-center cursor-pointer"
      >
        <img class="me-2" src="@/assets/icons/export.svg" alt="" /> 匯出Excel
      </div>
    </div>
  </div>
  <div class="filter">
    <div class="d-flex">
      <div class="col-4 d-flex">
        <CFormSelect
          @change="filterValue2 = $event.target.value"
          class="filter-selector me-3 rounded-pill"
        >
          <option value="all" @change="filterValue2 = null">
            用戶狀態：全部
          </option>
          <option value="1" @change="filterValue2 = '1'">
            用戶狀態：啟用
          </option>
          <option value="2" @change="filterValue2 = '2'">
            用戶狀態：凍結
          </option>
        </CFormSelect>
      </div>
      <div class="position-relative d-flex align-items-center col-4">
        <CFormInput
          class="rounded-pill pe-5"
          type="text"
          placeholder="請輸入企業名稱或相關資訊"
          v-model="filterValue"
        />
        <!-- <img
          class="position-absolute search"
          src="@/assets/icons/search.svg"
          alt=""
        /> -->
      </div>
    </div>
  </div>
  <CRow class="my-5 fw-bold col-12 mx-auto">
    <CCol xs="2" class="text-center">頭像</CCol>
    <CCol xs="2" class="text-center">公司名稱</CCol>
    <CCol xs="2" class="text-center">用戶創建日期</CCol>
    <CCol xs="2" class="text-center">聯絡電話</CCol>
    <CCol xs="2" class="text-center">用戶狀態</CCol>
  </CRow>
  <CRow
    v-for="item in filteredEnterpriseList"
    :key="item.name"
    class="mb-4 border list d-flex align-items-center col-12 mx-auto"
  >
    <CCol xs="2" class="text-center text-nowrap">
      <CImage v-if="item.avatar_image" height="65" :src="item.avatar_image" />
      <p
        v-else
        style="font-size: 14px; margin-bottom: 0; color: rgba(0, 0, 0, 0.4)"
      >
        未上傳頭像
      </p>
    </CCol>
    <CCol xs="2" class="text-center">{{ item.company_name }}</CCol>
    <CCol xs="2" class="text-center">{{ formatTimestamp(+item.created) }}</CCol>
    <CCol xs="2" class="text-center">{{ item.mobile }}</CCol>
    <CCol xs="2" class="text-center">
      <el-switch
        v-model="item.state"
        :disabled="!isButtonShow('sign/edit')"
        :active-value="$defines.User_Is_True"
        :inactive-value="$defines.User_Is_False"
        :before-change="checkChange"
        @change="changeState($event, item)"
      />
      <!-- <div
        class="state"
        :style="
          item.state === '1' ? 'background: #74D39C;' : 'background: #FE988E;'
        "
      >
        {{ item.state === '1' ? '啟用' : '凍結' }}
      </div> -->
    </CCol>
    <CCol xs="2" class="d-flex align-items-center justify-content-center">
      <CButton
        v-if="isButtonShow('sign/edit')"
        color="light"
        component="a"
        @click="
          $router.push(`/user-management/user-enterprise-list/${item.id}?currentPage=${currentPage}`)
        "
        class="list-btn me-2 text-nowrap"
      >
        編輯
        <img src="@/assets/icons/edit.svg" alt="" />
      </CButton>
      <CButton
        v-if="isButtonShow('sign/delete')"
        color="light"
        class="list-btn text-nowrap"
        @click="deleteInfo(item.id)"
      >
        刪除
        <img src="@/assets/icons/delete.svg" alt="" />
      </CButton>
    </CCol>
  </CRow>
  <div class="d-flex align-items-center justify-content-center py-4">
    <el-pagination
      background
      layout="prev, pager, next"
      :total="pagination.totalCount"
      :page-size="pagination.pageSize"
      @current-change="changePage"
    />
  </div>
  <MsgBox
    :show="showMsgBox"
    :errorCode="errorCode"
    :errorMsg="errorMsg"
    @close="showMsgBox = false"
  />
  <DeleteBox
    :show="showDeleteBox"
    :id="listId"
    @confirm="deleteUser"
    @close="showDeleteBox = false"
  />
</template>
<script>
import { ref } from '@vue/reactivity'
import useInfo from '@/composables/useInfo'
import MsgBox from '@/components/MsgBox.vue'
import DeleteBox from '@/components/DeleteBox.vue'
import { formatDate } from '@/utils/format-date.js'
import { computed } from '@vue/runtime-core'
import jsonToExcel from '@/utils/jsonToExcel'
import { useStore } from 'vuex'

export default {
  components: {
    MsgBox,
    DeleteBox,
  },
  setup() {
    const { getSignList, signDelete, signEdit } = useInfo()
    const options = ref(['時間： 全部', 2, 3, 4])
    const enterpriseList = ref([])
    const showMsgBox = ref(false)
    const showDeleteBox = ref(false)
    const errorMsg = ref('')
    const errorCode = ref('')
    const listId = ref('')
    const pagination = ref({})
    const currentPage = ref(1)
    const store = useStore()
    const getList = async () => {
      const res = await getSignList()
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        enterpriseList.value = res.ret.data
        pagination.value = res.ret.pagination
      }
    }

    getList()
    const isButtonShow = (key)=>{
      if(store.state.userInfo.auth_data === true){
        return true
      }else{
        return Object.values(store.state.userInfo.auth_data).includes(key)
      }
    }
    const changePage = async (page) => {
      currentPage.value = page
      const res = await getSignList({ page: currentPage.value })
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        enterpriseList.value = res.ret.data
        pagination.value = res.ret.pagination
      }
      document.scrollingElement.scrollTop = 0
    }
    const formatTimestamp = (timestamp) => {
      return formatDate(timestamp * 1000)
    }

    const deleteInfo = (id) => {
      listId.value = id
      showDeleteBox.value = true
    }
    const checkChange = () => {
      return window.confirm('是否要切換用戶狀態？')
    }
    const changeState = async (val, item) => {
      const userInfo = item
      userInfo.state = val
      const res = await signEdit(userInfo)
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        showMsgBox.value = true
        errorMsg.value = '編輯成功'
      }
    }

    const deleteUser = async () => {
      const res = await signDelete({ id: listId.value })
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        await getList()
      }
      showDeleteBox.value = false
    }

    const filterValue = ref('')
    const filterValue2 = ref('all')
    const filteredEnterpriseList = computed(() => {
      return enterpriseList.value
        ?.filter((e) => {
          const condition1 = filterValue.value.length
            ? e.company_name?.includes(filterValue.value)
            : true
          const condition2 =
            filterValue2.value === 'all'
              ? true
              : e.state?.includes(filterValue2.value)
          return condition1 && condition2
        })
    })

    const exportExcel = () => {
      const exportData = filteredEnterpriseList.value.map((item) => {
        return {
          company_name: item.company_name,
          created: formatTimestamp(item.created),
          mobile: item.mobile,
          email: item.email,
          state: item.state === '1' ? '啟用' : '凍結',
        }
      })

      const headers = {
        company_name: '公司名稱',
        created: '用戶創建日期',
        mobile: '聯絡電話',
        email: '電子郵件',
        state: '評估狀態',
      }
      jsonToExcel(headers, exportData, 'user-list')
    }
    return {
      options,
      enterpriseList,
      showMsgBox,
      errorMsg,
      formatTimestamp,
      getList,
      signEdit,
      checkChange,
      errorCode,
      deleteInfo,
      showDeleteBox,
      listId,
      filterValue,
      filterValue2,
      filteredEnterpriseList,
      exportExcel,
      deleteUser,
      changeState,
      pagination,
      currentPage,
      changePage,
      isButtonShow
    }
  },
}
</script>
<style lang="scss" scoped>
div {
  cursor: default;
}
.header {
  padding: 40px 0px;
}
h1 {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
}

.add-user {
  background: #d1e5ef;
  border-radius: 20px;
  height: 50px;
}
.filter {
  margin-top: 50px;
}

.search {
  right: 16px;
}
.list {
  height: 75px;
  border-radius: 20px;
}
.state {
  border-radius: 4px;
  color: #fff;
  width: 64px;
  height: 24px;
  font-size: 12px;
  display: flex;
  align-items: center;
  margin: auto;
  justify-content: center;
}
.list-btn {
  font-size: 12px;
  display: flex;
  align-items: center;
  width: 64px;
  height: 24px;
  img {
    width: 16px;
    margin-left: 10px;
  }
}

.is-hide{
  display: none;
}
</style>
